import { last, compact } from '@ally/utilitarian';
var fileExtRe = /\.\w+$/;
export var modules = new Map();
/**
 * Invoked by each remote in their "index" file to register it with the host
 * application.
 *
 * @example
 * window[Symbol.for('@ally/federator')].register('my-app', {
 *   setup,
 *   mount,
 *   unmount,
 * })
 */
export function register(id, exported) {
    var module = modules.get(id);
    if (module) {
        module.loaded = true;
        module.exports = exported;
    }
}
export function getModuleMetadata(host, source) {
    var _a = new URL(source, host), origin = _a.origin, pathname = _a.pathname;
    var parts = compact(pathname.split('/'));
    if (fileExtRe.test(last(parts) || ''))
        parts.pop();
    var root = new URL(parts.join('/'), origin).toString();
    return {
        root: root,
        origin: origin,
    };
}
// Adds the `register` method to the window so that remotes can call it in their
// initialization script. The `modules` property is also exposed so that we can
// namespace externals and prevent from leaking them to the window.
;
window[Symbol.for('@ally/federator')] = {
    modules: modules,
    register: register,
};
//# sourceMappingURL=modules.js.map